import React from 'react';

import 'scss/skeletons/breadcrumbs.scss';

const Skeleton: React.FC = () => (
    <div className="breadcrumbs-skeleton" />
);

export default Skeleton;
